import { HttpClient } from '@angular/common/http';
import {  Injector } from '@angular/core';
import * as FileSaver from 'file-saver';
import {  Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
export class BaseService {
http: HttpClient;
constructor(inject: Injector) {  this.http = inject.get(HttpClient);}
get apiUrl(): string { return `${environment.API_URL}/${environment.VERSION_URL}`;}
get cloudapiUrl() { return `${environment.AUTH_ISSUER}/api/v1`;}
get doc_api() { return `${environment.API_Document}`}
 // Below  methods are Generic
 get(endpoint: string, options?:any): Observable<any> {
    return this.http.get(`${this.apiUrl}${endpoint}`, options);
  }
  get_withFullUrl(url: string, options?:any): Observable<any> {
    return this.http.get(url, options);
  }
  // Get Multiple  Under Construction
  put(endpoint: string, data:any, options?:any): Observable<any> {
    return this.http.put(`${this.apiUrl}${endpoint}`, data, options);
  }

  post(endpoint: string, data?:any, options?:any): Observable<any> {
    return this.http.post(`${this.apiUrl}${endpoint}`, data, options);
  }
  patch(endpoint: string, data:any, options?:any): Observable<any> {
    return this.http.patch(`${this.apiUrl}${endpoint}`, data, options);
  }
  delete(endpoint: string, options?:any): Observable<any> {
    return this.http.delete(`${this.apiUrl}${endpoint}`, options);
  }
  logger(key:any,message:any)
  {
    if(environment.isDev){
    }
  }
  returnResult(res :any) {
    return res.result;
}

/**
 * Saves an .xlsx returned directly on the response body (single-call export).
 * Prefers the server-generated name from Content-Disposition, falling back to the supplied name
 * if that header is not readable (e.g. not exposed cross-origin).
 */
saveExcelResponse(response: any, fallbackFileName: string) {
  const fileName = this.getFileNameFromResponse(response) || fallbackFileName;
  const blob = new Blob([response.body], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  FileSaver.saveAs(blob, fileName);
}

private getFileNameFromResponse(response: any): string | null {
  const disposition = response?.headers?.get('Content-Disposition');
  if (!disposition) {
    return null;
  }
  // ASP.NET Core emits both forms; the RFC 5987 one wins when present.
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (encoded && encoded[1]) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch {
      // fall through to the plain form
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return plain && plain[1] ? plain[1].trim() : null;
}

/**
 * Reads an error message from a failed request made with responseType 'arraybuffer'.
 * Angular hands back the error body as raw bytes in that mode, so the usual
 * error.error.error.message lookup finds nothing and every failure would show the generic fallback.
 */
extractErrorMessage(error: any, fallback: string): string {
  try {
    const body = error?.error;
    if (body instanceof ArrayBuffer) {
      const text = new TextDecoder('utf-8').decode(new Uint8Array(body));
      if (!text) {
        return fallback;
      }
      const parsed = JSON.parse(text);
      return parsed?.error?.message || parsed?.message || fallback;
    }
    return error?.error?.error?.message || error?.error?.message || fallback;
  } catch {
    return fallback;
  }
}

downloadTempFile(file: any) {
  let url=environment.API_Document_Url+'/File/DownloadTempFile?fileType=' + file.fileType + '&fileToken=' + file.fileToken + '&fileName=' + file.fileName;;
  this.http.post(url,null, {
    responseType: 'arraybuffer',
    observe: 'response',
  }).subscribe((result:any)=>{
    const blob = new Blob([result.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, file.fileName);
})}

  // end
}
